import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'; import { MenuLateral } from '../MenuLateral/MenuLateral'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'; // Importa el icono faBars
import Nav from 'react-bootstrap/Nav';
import { fichaLam, fichaPes } from '../../Archivos/pluviometro';
import './Pluviometro.css';

export function Pluviometro() {

    const [fotoSeleccionada, setFotoSeleccionada] = useState(null);
    const [subtituloModal, setSubtituloModal] = useState("");

    const modalFoto = (foto, subtitulo) => {
        setFotoSeleccionada(foto);
        setSubtituloModal(subtitulo)
    };

    const logoPdf = <FontAwesomeIcon icon={faFilePdf} size="xl" style={{ color: "#006c87", }} />

    const abrirPdf = (archivo) => {
        window.open(archivo, '_blank');
    };

    const archivosPDF = {

        fichaLam: fichaLam,
        fichaPes: fichaPes
    };

    const clicEnlacePdf = (tipoArchivo) => {
        abrirPdf(archivosPDF[tipoArchivo]);
    };

    return (
        <>
            <div className="mainContainer">
                <MenuLateral />

                <div className='contenedorProducto'>
                    <div className='row'>
                        <div className='col-xl-3 col-lg-3 col-md-12 col-sm-12'>
                            <div className='imagenesPluviometro'>

                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoPluviometro"
                                            src={require("../Img/pluviometro.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/pluviometro.webp"), 'Pluviómetro')}
                                            alt='Pluviómetro' />
                                    </div>
                                </Row>

                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className='descripcionPluviometro'>
                                <h2 className='nombreProductoPluviometro'>Pluviómetro</h2>
                                <h5 className='tituloProductoPluviometro'>El pluviómetro es un sensor de precipitación de
                                    pesaje que mide la cantidad de lluvia por un cubo de inflexión desarrollado por Joss-Tognini,
                                    fijado a unos cojinetes desarrollados para una muy baja fricción.</h5>
                                <p className='textoProductoPluviometro'>
                                    Los errores que se producen, normalmente debidos al drenaje incompleto causado por la tensión
                                    superficial, se compensan automáticamente por la forma específica de la cubeta de inflexión.
                                    
                                </p>
                            </div>
                        </div>


                        <div className='col-lg-3 col-md-12'>

                            <div className='contenedorNavPluviometro'>
                                <Nav as="ul" className="flex-column">
                                    <Nav.Item className='linksArchivosPluviometro' as="li" onClick={() => clicEnlacePdf('fichaLam')}>
                                        {logoPdf}
                                        Ficha Pluviometro Lambrecht
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosPluviometro' as="li" onClick={() => clicEnlacePdf('fichaPes')}>
                                        {logoPdf}
                                        Ficha Pluviometro Pessl
                                    </Nav.Item>

                                </Nav>
                            </div>
                        </div>
                    </div>

                </div>

            </div >

            <Modal className='imgModalContainer' show={fotoSeleccionada !== null} onHide={() => setFotoSeleccionada(null)}>
                <Modal.Header closeButton>
                    {subtituloModal && <Modal.Title>{subtituloModal}</Modal.Title>}
                </Modal.Header>
                <Modal.Body>
                    {fotoSeleccionada && (<img src={fotoSeleccionada} alt="Foto Pluviometro" className="imgModal" />)}
                </Modal.Body>
            </Modal>

        </>
    );

}

